import {CountrySelectorApi} from "../Api/CountrySelectorApi";
import Cookies from "js-cookie";

export default (): CountrySelectorComponent => ({
    isOpen: false,
    country: null,
    closeButtonText: null,
    flagUrl: null,
    message: null,
    url: null,
    handleClose() {
        this.isOpen = false;
        Cookies.set("no-country-selector", true);
    },
    async init() {
        if (!!window.Cookiebot && window.Cookiebot.consent.necessary) {
            const cookie = Cookies.get("no-country-selector");
            if (!cookie) {
                const response = await fetch("https://ipapi.co/json");
                const json = await response.json();
                const currentCountry = document.querySelector("html").getAttribute("country");
                const res = await CountrySelectorApi.get(json,currentCountry);
                this.isOpen = res.showCountryMessage;
                this.country = res.country;
                this.closeButtonText = res.closeButtonText;
                this.flagUrl = res.flagUrl;
                this.message = res.message;
                this.url = res.url;
                if (!res.showCountryMessage) {
                    Cookies.set("no-country-selector", true);
                }
            }
        }
    }
})

import {AlpineComponent} from "alpinejs"

type CountrySelectorComponent = AlpineComponent<{
    isOpen: boolean,
    handleClose: Function
}>
